import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import NavbarEnlaces from "../../../layout/NavbarEnlaces";
import Modal from "../../../layout/Modal/Modal";
import ListBadge from "../../../layout/ListBadge";
import { dataResultadosE2021 } from "../../../data/dataProcesosElectorales";

const ProcesosElectorales = () => {
  useEffect(() => {
    document.title = `Procesos Electorales`;
  }, []);
  return (
    <>
      <NavbarEnlaces title="Resultados Electorales" />
      <div className="margin-bottom-1"> 
        <div className="Content__grid">
          <div>
            <Link to="/HistorialPE">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/e20.png"
                alt="Historial de Resultados 1995 - 2013"
              />
            </Link>
            <p className="mt-2">Historial de Resultados (1995 - 2013)</p>
          </div>
          <div>
            <Link to="/PE20152016">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/e19.png"
                alt="Proceso Electoral 2015 -2015"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2015 - 2016</p>
          </div>
          <div>
            <Link to="/PEE2017">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/e19.png"
                alt="Proceso Electoral Extraordinario 2017"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2017</p>
          </div>
          <div>
            <Link to="/PE2018">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/e19.png"
                alt="Proceso Electoral 2018"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2017 - 2018</p>
          </div>
          <div>
            <Link to="/PE20202021">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/e19.png"
                alt="Proceso Electoral 2020 - 2021"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2020 - 2021</p>
          </div>
          <div>
            <a
              href="/#"
              rel="noreferrer"
              data-bs-toggle="modal"
              data-bs-target="#PresidenciasComunidad2021"
            >
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/e19.png"
                alt="Proceso Electoral Extraordinario 2021"
              />
            </a>
            <p className="mt-2">Proceso Electoral Extraordinario 2021</p>
          </div>
          <div>
            <Link to="/PE20232024">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/e19.png"
                alt="Proceso Electoral 2023 - 2024"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2023 - 2024 <br></br>Proceso Electoral Extraordinario 2024</p>
          </div>
        </div>
      </div>

      {/* ELECCION JUDICIAL */}

      <div className="margin-bottom-1 mt-5">
        <div className="Enlances__title mb-4">Resultados Electorales Judiciales</div>
        <div className="Content__grid">
        <div>
            <Link to="/PEPJ20242025">
              <img
                className="img-fluid"
                src="https://itetlax.org.mx/assets/img/icons/e19.png"
                alt="Proceso Electoral 2023 - 2024"
              />
            </Link>
            <p className="mt-2">Proceso Electoral Extraordinario para el Poder Judicial Local 2024-2025</p>
          </div>
        </div>
      </div>
      {/* Modal */}
      <Modal
      idModal="PresidenciasComunidad2021"
      titleModal="Resultados Electorales Presidencias de Comunidad 2021"
      sizeModal=""
      contentModal={
        <ListBadge ifNumbered={""} listsBadgeItem={dataResultadosE2021} />
      }
      />
    </>
  );
};
export default ProcesosElectorales;
